var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"items":_vm.items,"attach":"","chips":"","color":"green","item-color":"green","multiple":""},model:{value:(_vm.tags),callback:function ($$v) {_vm.tags=$$v},expression:"tags"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }